export default __webpack_public_path__ + "00e432d0cd88272c36a403f08900766b.png";